import { useCreditsQuery } from "../query";

/**
 * Глобальна монетизація з одного кешу credits (React Query).
 * Той самий useCreditsQuery, що й useCreditsBalance — без дублювання запитів.
 */
export const useGlobalMonetization = () => {
  const { data: credits, isLoading: loading } = useCreditsQuery();

  const subscription = credits?.subscription ?? null;
  const hasPremiumSubscription =
    subscription?.status?.toLowerCase() === "active" &&
    subscription?.tier !== "freemium";

  return {
    credits: credits ?? null,
    subscription,
    hasPremiumSubscription,
    loading,
  };
};
